import type { HttpTransport } from '@dealr/transport';

/**
 * Re-rejects from inside a callback on `transport`'s promises. AngularJS 1.5's `$q` reports anything a callback
 * throws to `$exceptionHandler`, so this defers to the transport's own `reject`: the AngularJS adapter's returns
 * `$q.reject` when built with `ngQ` and throws without it. A transport with no `reject` (fetch) gets a plain throw,
 * exactly as `throw reason` did. Return its result from the callback.
 */
export function rejectThrough(transport: Pick<HttpTransport, 'reject'>, reason: unknown): PromiseLike<never> {
  if (typeof transport.reject === 'function') return transport.reject(reason);
  throw reason;
}
